import LocalSettings from "nexia_mobile/models/local_settings";
import Group from "nexia_mobile/models/mixins/device_features/group";
import DeviceModel from "nexia_mobile/models/device";
import AutomationModel from "nexia_mobile/models/automation";
import { getLanguageSet } from "nx-components/Locales";

class DefaultSorter {
  constructor(devices) {
    this.items = devices;
  }

  sort() {
    return this.items;
  }

  _nameSort(items) {
    return _(items).sortBy((item) => {
      let name = item.get("name");
      return (name || "").toLowerCase();
    });
  }
}

class NameSorter extends DefaultSorter {
  sort() {
    return this._nameSort(this.items);
  }
}

class SegmentedSorter extends DefaultSorter {
  _segmentedSort(sortCriteriaFunction) {
    let split = _.partition(this.items, (item) => {
      return sortCriteriaFunction(item);
    });
    return _.union(split[0], split[1]);
  }

  sort() {
    return this._segmentedSort(this.sorter);
  }
}

class AutomationsFirstSorter extends SegmentedSorter {
  sorter(item) {
    return item instanceof AutomationModel;
  }
}

class DevicesFirstSorter extends SegmentedSorter {
  sorter(item) {
    return item instanceof DeviceModel && !item.hasFeature(Group);
  }
}

class GroupsFirstSorter extends SegmentedSorter {
  sorter(item) {
    return item instanceof DeviceModel && item.hasFeature(Group);
  }
}

class DeviceSorter {
  sorters() {
    const language = getLanguageSet().nexia_mobile.models.device_sorter;
    return {
      name: {
        sorter: NameSorter,
        description: language.nameSortDescription,
      },
      default: {
        sorter: DevicesFirstSorter,
        description: language.devicesSortDescription,
      },
      "groups-first": {
        sorter: GroupsFirstSorter,
        description: language.groupSortDescription,
      },
    };
  }

  chosenSorter() {
    let sorterClass = this.sorters()[LocalSettings.getDeviceSortOrder()];
    if (!sorterClass || !sorterClass.sorter) {
      return AutomationsFirstSorter;
    }
    return sorterClass.sorter;
  }

  descriptions() {
    return _(this.sorters()).pluck("description");
  }
  values() {
    return _(this.sorters()).keys();
  }

  sort(devices) {
    return new (this.chosenSorter())(devices).sort();
  }
}

if (DeviceSorter.singleton == null) {
  DeviceSorter.singleton = new DeviceSorter();
}

export default DeviceSorter.singleton;



// WEBPACK FOOTER //
// ./src/models/device_sorter.js